import {createAction} from 'redux-act';
import {AxiosPromise} from 'axios';

import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

import {PaymentsType} from '../payment/types';

import {OrderDataType, PlaceOrderResponseSuccessType} from './types';

/**
 * Place order action for start saga
 */
export const placeOrderSaga = createAction<PaymentsType['code']>(
    'POST_PURCHASE_INSURANCE_PLACE_ORDER_SAGA',
);

/**
 * Place order action
 */
export const placeOrder = createAction(
    'POST_PURCHASE_INSURANCE_PLACE_ORDER',
    ({insurances, payment, token}: OrderDataType): AxiosPromise<PlaceOrderResponseSuccessType> => {
        return instanceGusaBackend({
            method: 'post',
            url: ENDPOINTS.POST_PURCHASE_INSURANCE_ORDER({token}),
            data: {
                insurances,
                payment,
            },
        });
    },
);

/**
 * Sets order ID for correct rendering of "Thank You" page
 */
export const setOrderId = createAction<string>('POST_PURCHASE_INSURANCE_SET_ORDER_ID');
